export default __webpack_public_path__ + "static/media/real-time_collaboration.d0a8f6c9.svg";